import { render, staticRenderFns } from "./RewardPayList.vue?vue&type=template&id=44e06435&"
import script from "./RewardPayList.vue?vue&type=script&lang=js&"
export * from "./RewardPayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports